import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";

export class StudentSessionBehaviourModel extends ModelBase<StudentSessionBehaviourModel> {
    public studentSessionId: string | null = null;
    public studentBehaviourId: string | null = null;
    public score: number | null = null;

    constructor() {
        super();
        makeObservable(this, {
            score: observable,
        });
    }
}

export class StudentSessionBehaviourModelValidator extends Validator<StudentSessionBehaviourModel> {
    constructor() {
        super();
        this.ruleFor("score")
            .notNull()
            .withMessage("A behaviour score must be provided")
            .must({
                predicate: (val) => (val as unknown) !== "",
                message: "A behaviour score must be provided",
            });
    }
}
